import React from 'react';
export function HookSection() {
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-385">
      <div className="max-w-[680px] mx-auto font-body" data-id="element-386">
        <div className="space-y-6 text-dark-gray text-lg md:text-xl leading-relaxed" data-id="element-387">
          <p data-id="element-388">
            Si alguna vez intentaste aprender crochet y terminaste con hilo
            enredado, un tutorial confuso en YouTube y cero avance…
          </p>
          <p data-id="element-389">
            Esta guía (y los 5 bonos que vienen con ella) son exactamente lo que
            necesitabas desde el principio.
          </p>
          <p className="font-bold text-pink-dark" data-id="element-390">
            Porque el problema nunca fue tu habilidad.
          </p>
          <p className="font-bold text-xl md:text-2xl" data-id="element-391">
            Fue que nadie te dio un sistema completo.
          </p>
        </div>
      </div>
    </section>;
}